import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import TestResultDemo from './TestResultDemo'
import TestResultElement from './TestResultElement'
import TestResultFormBrand from './TestResultFormBrand'
import { STYLE_FORM_SCHEMA } from './TestResultFormStyle'
import TestResultFormValue from './TestResultFormValue'
import resultIcon from './assets/testResult.svg'

export default genElementConfig(CONFIG_ELEMENTS.testResult, {
  label: t('elements.testResult.label'),
  icon: resultIcon,
  group: ElementGroup.test,
  styleFields: STYLE_FORM_SCHEMA,
  Element: TestResultElement,
  Demo: [TestResultDemo],
  FormValue: TestResultFormValue,
  FormBrand: TestResultFormBrand,
  EditorActions: null,
})
